import LastTableCell from '@framework/ui/Molecules/Tables/TableWrapper/LastTableCell';
import { useStatsContext } from '@/creditflowresearch/application/ArticlesAndStats/Stats/StatsContext';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';
import IconDownload from '@creditflowresearch/uilib/Icon/IconDownload';
import IconButton from '@creditflowresearch/uilib/IconButton';
import { formatDateOrTime } from '@/creditflowresearch/ui/components/ActiveCalendar/helpers/dates';
import { MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import Tooltip from '@creditflowresearch/uilib/Tooltip';

import styles from './styles.module.scss';

const UpdatedAtCell = ({ row: { updatedAt, attachment } }) => {
  const { downloadAttachment } = useStatsContext();
  const { timeZone } = useUserTimeZoneContext();
  const updatedAtDate = updatedAt ? formatDateOrTime(updatedAt, timeZone, MONTH_DAY_YEAR_FORMAT, true) : '-';

  return (
    attachment ? (
      <LastTableCell
        childrenToShowOnHover={ (
          <Tooltip content="Download">
            <IconButton
              icon={ <IconDownload className={ styles.downloadIcon } /> }
              className={ styles.downloadButton }
              ariaLabel={ `Download ${ attachment.displayName }` }
              dataTest="downloadAttachment"
              onClick={ () => downloadAttachment({
                displayName: attachment.displayName,
                uploadId: attachment.uploadId,
              }) }
            />
          </Tooltip>
      ) }
      >
        { updatedAtDate }
      </LastTableCell>
    ) : (<>{ updatedAtDate }</>)
  );
};

export default UpdatedAtCell;
